import { defineMessages } from 'react-intl'
import { SUPPORT_PHONE_NUMBER } from 'hfty'
export default defineMessages({
  'prod_react_error_title': {
    id: 'prod_react_error_title',
    defaultMessage: 'Something went wrong!',
  },
  'prod_react_error_subtitle': {
    id: 'prod_react_error_subtitle',
    defaultMessage: 'Information:',
  },
  'prod_react_error_msg1': {
    id: 'prod_react_error_msg1',
    defaultMessage: 'We apologize for any convenience. ' +
    'Please refresh the page. If you are still having issues please contact',
  },
  'prod_react_error_msg2': {
    id: 'prod_react_error_msg2',
    defaultMessage: ` or call ${SUPPORT_PHONE_NUMBER}.`,
  },
  'support_email': {
    id: 'support_email',
    defaultMessage: 'agphd.helpdesk@farmersedge.ca',
  },
})
